module.exports = __webpack_public_path__ + "img/shop_tree-1.2a6fe0a4.png";